import { Link } from "react-router-dom";
import { ArrowUpRight, CalendarCheck, Route, GraduationCap } from "lucide-react";
import { Reveal, SectionHead } from "../components/ui-bits";
import { IMAGES } from "../config/images";

export default function Partners() {
  return (
    <section id="partners" className="relative py-20 lg:py-28" data-testid="partner-teaser-section">
      <div className="container-x grid grid-cols-1 items-center gap-12 lg:grid-cols-12">
        <Reveal className="order-2 lg:order-1 lg:col-span-5">
          <div className="relative overflow-hidden rounded-3xl border border-white/10">
            <img src={IMAGES.partnerIndia} alt="A CARZA service partner in an Indian residential society" className="aspect-[4/5] w-full object-cover sm:aspect-[3/4] lg:aspect-[4/5]" loading="lazy" data-testid="partner-teaser-image" />
            <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, transparent 40%, rgba(19,8,38,0.85))" }} />
            <div className="absolute bottom-5 left-5 right-5">
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-carza-lite">The CARZA partner network</p>
              <p className="mt-2 text-sm leading-relaxed text-mist">Trained. Verified. Equipped. Built for Indian cities.</p>
            </div>
          </div>
        </Reveal>

        <div className="order-1 lg:order-2 lg:col-span-7 lg:pl-6">
          <SectionHead
            eyebrow="Partner Opportunity"
            title={<>Stop Searching for Customers. Start Building With CARZA.</>}
            sub="Get access to nearby bookings, training, digital tools and a growing network of vehicle owners."
          />
          <div className="mt-9 grid grid-cols-1 gap-3 sm:grid-cols-3">
            {[
              { icon: CalendarCheck, t: "Nearby bookings", d: "Customer demand routed to you." },
              { icon: Route, t: "Less travel", d: "Work close to your area." },
              { icon: GraduationCap, t: "Training & SOPs", d: "Learn the CARZA standard." },
            ].map((b, i) => (
              <Reveal key={b.t} delay={0.08 + i * 0.05}>
                <div className="card-surface h-full rounded-2xl p-5" data-testid={`partner-teaser-value-${i}`}>
                  <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-carza-dim text-carza-lite"><b.icon size={16} /></span>
                  <p className="mt-3 text-sm font-semibold text-paper">{b.t}</p>
                  <p className="mt-1 text-xs leading-relaxed text-mist">{b.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2} className="mt-8">
            <Link to="/partners" className="btn btn-primary px-8 py-4" data-testid="partner-teaser-cta">
              Become a CARZA Partner <ArrowUpRight size={16} />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
